import { render, staticRenderFns } from "./Claims.vue?vue&type=template&id=812f3524"
import script from "../../script/claims/claims.js?vue&type=script&lang=js&external"
export * from "../../script/claims/claims.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports